import CustomAdvanceTable from 'components/common/advance-table/CustomAdvanceTable';
import Avatar from 'components/common/Avatar';
import Flex from 'components/common/Flex';
import SoftBadge from 'components/common/SoftBadge';
import TableRowAction from 'components/common/TableRowAction';
import {
  weDonarItems,
  weDonarNotifications,
  weDonarTableData,
  weUserImage
} from 'data/weraise-data/donar-data';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import DonorCounter from './DonarCounter';

const Donors = () => {
  const navigate = useNavigate();
  const columns = [
    {
      accessor: 'id',
      Header: 'ID',
      cellProps: {
        className: 'py-2'
      }
    },
    {
      accessor: 'name',
      Header: 'Name',
      cellProps: {
        className: 'py-2'
      },
      Cell: rowData => {
        const { name, id } = rowData.row.original;
        return (
          <Flex alignItems="center">
            <Avatar src={weUserImage} rounded="circle" size="xl" />
            <Link
              to={`/donors/${id}`}
              className="fw-medium ms-2 text-1100 hover-primary"
            >
              {name}
            </Link>
          </Flex>
        );
      }
    },
    {
      accessor: 'email',
      Header: 'Email',
      cellProps: {
        className: 'py-2'
      },
      Cell: rowData => {
        const { email } = rowData.row.original;
        return (
          <a className="fw-medium text-600" href={'mailto:' + email}>
            {email}
          </a>
        );
      }
    },
    {
      accessor: 'phone',
      Header: 'Phone',
      cellProps: {
        className: 'py-2'
      },
      Cell: rowData => {
        const { phone } = rowData.row.original;
        return (
          <a className="fw-medium text-600" href={'callTo:' + phone}>
            {phone}
          </a>
        );
      }
    },
    {
      accessor: 'address',
      Header: 'Address',
      cellProps: {
        className: 'fw-medium text-600 py-2'
      }
    },

    {
      accessor: 'score',
      Header: 'Donor Score',
      cellProps: {
        className: 'fw-medium py-2'
      },

      Cell: rowData => (
        <SoftBadge pill bg={rowData.row.original.variant} className="me-2">
          {rowData.row.original.score}
        </SoftBadge>
      )
    },
    {
      accessor: 'id_',
      Header: '',
      cellProps: {
        className: 'py-2 text-end'
      },
      disableSortBy: true,

      Cell: rowData => {
        const { id } = rowData.row;
        return (
          <TableRowAction
            onCLickEdit={() => console.log(id)}
            onCLickDelete={() => console.log(id)}
          />
        );
      }
    }
  ];

  return (
    <>
      <Row>
        <Col>
          <DonorCounter
            counterData={weDonarItems}
            notifications={weDonarNotifications}
          />
        </Col>
      </Row>
      <Row>
        <Col md={12} xxl={12} className="h-md-100">
          <CustomAdvanceTable
            data={weDonarTableData}
            columns={columns}
            title="Donors list"
            addButtonLabel="Add New Donor"
            showSearchInput
            searchInputPlaceHolder="Search Accounts"
            onClickAddNew={() => navigate('/donors/add-new-donar')}
          />
        </Col>
      </Row>
    </>
  );
};

export default Donors;
